<template>
    <div id="admin_excluded_keywords_page" class="container-fluid">
        <h4 class="margin-left10 margin-bottom20 pull-left">Client: {{ client.name || 'All Clients' }}</h4>
        <button @click="resetModalData" type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#add_new_keyword">+ Add New Keyword</button>

        <div class="modal fade" id="add_new_keyword" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add New Keyword</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <input id="new_keyword" v-model="new_keyword" type="text" class="form-control">

                        <div class="text-center margin-top20">
                            <label class="margin-right20">
                                <input v-model="new_keyword_type" type="radio" name="new_keyword_type" class="margin-right5" value="Brand Term">Brand Term
                            </label>

                            <label>
                                <input v-model="new_keyword_type" type="radio" name="new_keyword_type" class="margin-right5" value="Spam">Spam
                            </label>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewKeyword" :disabled="!new_keyword || !new_keyword_type" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="keyword_to_exclude" slot-scope="props">
                <div v-if="!props.row.edit_mode">{{ props.row.keyword_to_exclude }}</div>
                <input v-if="props.row.edit_mode" type="text" class="form-control edit-excluded-keyword" :value="props.row.keyword_to_exclude">
            </div>

            <div slot="keyword_type" slot-scope="props" class="keyword-types">
                <div v-if="!props.row.edit_mode">{{ props.row.keyword_type }}</div>

                <label v-if="props.row.edit_mode" class="margin-bottom0">
                    <input :checked="props.row.keyword_type === 'Brand Term'" type="radio" class="margin-right5" :name="`keyword_type_${props.row.id}`" value="Brand Term">Brand Term
                </label>

                <label v-if="props.row.edit_mode" class="margin-left20 margin-bottom0">
                    <input :checked="props.row.keyword_type === 'Spam'" type="radio" class="margin-right5" :name="`keyword_type_${props.row.id}`" value="Spam">Spam
                </label>
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <button v-if="!props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn btn-info reverse">Edit</button>
                <button v-if="props.row.edit_mode" @click="save(props.row.id, $event)" class="btn btn-success reverse">Save</button>
                <button v-if="props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn cancel-editing">Cancel</button>
                <button v-if="!props.row.edit_mode" @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            if (this.$route.params.id) {
                axios.get(`/api/clients/${this.$route.params.id}`).then(response => {
                    this.client = response.data;
                });
            }

            this.fetchServerData();
        },

        data() {
            return {
                client: {},
                new_keyword: '',
                new_keyword_type: 'Brand Term',
                columns: ['keyword_to_exclude', 'keyword_type', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        keyword_to_exclude: 'Excluded Keywords',
                        keyword_type:       'Keyword Type',
                        actions:            ''
                    },
                    sortable: ['keyword_to_exclude', 'keyword_type'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} keywords|{count} keywords|One keyword',
                        filter: '',
                        filterPlaceholder: 'Search keywords...',
                        noResults: 'No matching keywords'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/admin/excluded-keywords?client_id=${this.$route.params.id || ''}`)
                ])
                .then(axios.spread(excludedKeywords => {
                    _.each(excludedKeywords.data, item => {
                        item.edit_mode = false;
                    });

                    this.tableData = excludedKeywords.data;
                }));
            },

            resetModalData() {
                this.new_keyword      = '';
                this.new_keyword_type = 'Brand Term';
            },

            addNewKeyword() {
                $('#add_new_keyword').modal('hide');

                axios.post(`/api/admin/excluded-keywords?client_id=${this.$route.params.id || ''}`, {
                    keyword:      this.new_keyword,
                    keyword_type: this.new_keyword_type
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Keyword has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            toggleEditMode(id) {
                const index = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = !this.tableData[index].edit_mode;
                }
            },

            save(id, event) {
                const newKeyword     = $(event.target).closest('tr').find('.edit-excluded-keyword').val();
                const newKeywordType = $(event.target).closest('tr').find('input[type="radio"]:checked').val();
                const index          = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = false;
                }

                axios.put(`/api/admin/excluded-keywords/${id}?client_id=${this.$route.params.id || ''}`, {
                    keyword:      newKeyword,
                    keyword_type: newKeywordType
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Keyword has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            remove(id) {
                this.confirmation('Are you sure you want to delete this keyword?', () => {
                    axios.delete(`/api/admin/excluded-keywords/${id}?client_id=${this.$route.params.id || ''}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Keyword has been successfully deleted.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #admin_excluded_keywords_page {
        .edit-excluded-keyword {
            width: auto;
            height: 3.4rem;
        }

        .cancel-editing {
            padding: 0.8rem 1.65rem;
        }

        input[type="radio"] {
            position: relative;
            top: .1rem;
        }

        .VueTables__search {
            display: none;
        }

        .VueTables__table {
            table-layout: fixed;
        }
    }
</style>
